module.exports = __webpack_public_path__ + "static/1323344124.bb76aa80.jpg";